import { Button } from '@/components/ui/button';
import type { DestinationOption } from '@/types/provider-destinations';

import { CHANNEL_ICONS, CHANNEL_LABELS, formatLastSuccess } from '../utils';
import { VerificationBadge } from '../VerificationBadge';

interface SearchResultItemProps {
  result: DestinationOption;
  onSelect: (result: DestinationOption) => void;
}

export const SearchResultItem = ({
  result,
  onSelect,
}: SearchResultItemProps) => {
  const ChannelIcon = CHANNEL_ICONS[result.channel_type];
  const evidenceText =
    typeof result.evidence_summary === 'string' &&
    result.evidence_summary.trim().length > 0
      ? result.evidence_summary.trim()
      : null;

  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border px-3 py-2.5">
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <div className="flex size-7 shrink-0 items-center justify-center rounded bg-zinc-100">
          <ChannelIcon className="size-3.5 text-zinc-600" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <span className="truncate text-sm font-medium text-zinc-900">
              {result.value}
            </span>
            <VerificationBadge status={result.verification_status} />
          </div>
          <div className="flex items-center gap-2 text-xs text-zinc-500">
            <span>{CHANNEL_LABELS[result.channel_type]}</span>
            {result.confidence_score != null && (
              <>
                <span aria-hidden="true">&middot;</span>
                <span>{Math.round(result.confidence_score * 100)}%</span>
              </>
            )}
            {evidenceText && (
              <>
                <span aria-hidden="true">&middot;</span>
                <span className="truncate">
                  {evidenceText}
                </span>
              </>
            )}
            {result.last_success_at !== undefined && (
              <>
                <span aria-hidden="true">&middot;</span>
                <span>{formatLastSuccess(result.last_success_at)}</span>
              </>
            )}
          </div>
        </div>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={() => onSelect(result)}
      >
        Use
      </Button>
    </div>
  );
};
